import React from 'react';
import { Modal } from 'antd';
import { AudienceNotVisibleError } from '../../types/memo';

const userName = (u: { Profile?: { FirstName?: string; LastName?: string } }) =>
  `${u?.Profile?.FirstName || ''} ${u?.Profile?.LastName || ''}`.trim() || 'Unknown user';

/**
 * Shown when the API answers 422 audience_not_visible: some required signers
 * cannot see the memo. Resolves true when the user chooses to grant access.
 */
export const confirmGrantAccess = (conflict: AudienceNotVisibleError): Promise<boolean> =>
  new Promise(resolve => {
    const names = (conflict.Users || []).map(userName);
    Modal.confirm({
      title: 'Some required signers cannot view this document',
      zIndex: 2300,
      content: (
        <div>
          <p>
            The following people must acknowledge the memo but do not have access to it under the
            current library permissions:
          </p>
          <ul>
            {names.map(n => (
              <li key={n}>{n}</li>
            ))}
          </ul>
          <p>Grant them view access to this document and save?</p>
        </div>
      ),
      okText: 'Grant access and save',
      cancelText: 'Cancel',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
